// src/components/AcademicWritingCards/AcademicWritingCards.js
import React from 'react';
import AOSInitializer from '../../AOSInitializer';

export const AcademicWritingCards = () => {
  return (
    <>
      <AOSInitializer />
      <div className="row">
        {/* card 01 */}
        <div className="col-lg-4 col-md-6 col-sm-12 text-start p-1" data-aos="flip-left">
          <div className="service-item service-dianuj">
            <div className="service-single">
              <div className="service-img">
                <img
                  src="/images/academic1.jpg"
                  alt="Service Frequency Calculator"
                  height="200px"
                  width="100%"
                />
              </div>
              <div className="service-content long-heading">
                <h3>
                  <a className="" href="/Academic_Services">
                    Essay Writing
                  </a>
                </h3>
                <p>
                  Crafting custom essays on a variety of topics and across
                  different academic levels.
                </p>
                <a href="/Academic_Services">Check Now</a>
              </div>
            </div>
          </div>
        </div>
        {/* card 02 */}
        <div className="col-lg-4 col-md-6 col-sm-12 text-start p-1" data-aos="flip-right">
          <div className="service-item service-dianuj">
            <div className="service-single">
              <div className="service-img">
                <img
                  src="/images/academic2.jpg"
                  alt="Service Frequency Calculator"
                  height="200px"
                  width="100%"
                />
              </div>
              <div className="service-content long-heading">
                <h3>
                  <a className="" href="/Academic_Services">
                    Research Papers
                  </a>
                </h3>
                <p>
                  Writing detailed papers that involve extensive research,
                  critical analysis, and synthesis of information related to a
                  specific topic.
                </p>
                <a href="/Academic_Services">Check Now</a>
              </div>
            </div>
          </div>
        </div>
        {/* card 03 */}
        <div className="col-lg-4 col-md-6 col-sm-12 text-start p-1" data-aos="flip-left">
          <div className="service-item service-dianuj">
            <div className="service-single">
              <div className="service-img">
                <img
                  src="/images/academic3.jpg"
                  alt="Service Frequency Calculator"
                  height="200px"
                  width="100%"
                />
              </div>
              <div className="service-content long-heading">
                <h3>
                  <a className="" href="/Academic_Services">
                    Thesis Writing
                  </a>
                </h3>
                <p>
                  Providing support in writing comprehensive theses for
                  undergraduate and postgraduate students, including proposal
                  development and literature review.
                </p>
                <a href="/Academic_Services">Check Now</a>
              </div>
            </div>
          </div>
        </div>
        {/* card 04 */}
        <div className="col-lg-4 col-md-6 col-sm-12 text-start p-1" data-aos="flip-right">
          <div className="service-item service-dianuj">
            <div className="service-single">
              <div className="service-img">
                <img
                  src="/images/academic4.jpg"
                  alt="Service Frequency Calculator"
                  height="200px"
                  width="100%"
                />
              </div>
              <div className="service-content long-heading">
                <h3>
                  <a className="" href="/Academic_Services">
                    Dissertation Writing
                  </a>
                </h3>
                <p>
                  Providing support in writing comprehensive theses for
                  undergraduate and postgraduate students, including proposal
                  development and literature review.
                </p>
                <a href="/Academic_Services">Check Now</a>
              </div>
            </div>
          </div>
        </div>
        {/* card 05 */}
        <div className="col-lg-4 col-md-6 col-sm-12 text-start p-1" data-aos="flip-left">
          <div className="service-item service-dianuj">
            <div className="service-single">
              <div className="service-img">
                <img
                  src="/images/academic5.jpg"
                  alt="Service Frequency Calculator"
                  height="200px"
                  width="100%"
                />
              </div>
              <div className="service-content long-heading">
                <h3>
                  <a className="" href="/Academic_Services">
                    Case Studies
                  </a>
                </h3>
                <p>
                  Creating detailed analysis of a particular case or scenario
                  within a real-world context, often used in business and law
                  schools.
                </p>
                <a href="/Academic_Services">Check Now</a>
              </div>
            </div>
          </div>
        </div>
        {/* card 06 */}
        <div className="col-lg-4 col-md-6 col-sm-12 text-start p-1" data-aos="flip-right">
          <div className="service-item service-dianuj">
            <div className="service-single">
              <div className="service-img">
                <img
                  src="/images/academic6.jpg"
                  alt="Service Frequency Calculator"
                  height="200px"
                  width="100%"
                />
              </div>
              <div className="service-content long-heading">
                <h3>
                  <a className="" href="/Academic Writing//SubAcademicPage2.html">
                    Term Papers
                  </a>
                </h3>
                <p>
                  Writing term papers that require students to discuss a
                  concept, event, or point of view related to the course
                  content.
                </p>
                <a href="/Academic Writing//SubAcademicPage2.html">Check Now</a>
              </div>
            </div>
          </div>
        </div>
        {/* card 07 */}
        <div className="col-lg-4 col-md-6 col-sm-12 text-start p-1" data-aos="flip-left">
          <div className="service-item service-dianuj">
            <div className="service-single">
              <div className="service-img">
                <img
                  src="/images/academic7.jpg"
                  alt="Service Frequency Calculator"
                  height="200px"
                  width="100%"
                />
              </div>
              <div className="service-content long-heading">
                <h3>
                  <a className="" href="/Academic_Services">
                    Annotated Bibliographies
                  </a>
                </h3>
                <p>
                  Compiling lists of sources with annotations that provide a
                  summary and an evaluation of each source.
                </p>
                <a href="Academic Writing/SubAcademicPage3.html">Check Now</a>
              </div>
            </div>
          </div>
        </div>
        {/* card 08 */}
        <div className="col-lg-4 col-md-6 col-sm-12 text-start p-1" data-aos="flip-right">
          <div className="service-item service-dianuj">
            <div className="service-single">
              <div className="service-img">
                <img
                  src="/images/academic8.jpg"
                  alt="Service Frequency Calculator"
                  height="200px"
                  width="100%"
                />
              </div>
              <div className="service-content long-heading">
                <h3>
                  <a className="" href="/Academic_Services">
                    Book Reviews
                  </a>
                </h3>
                <p>
                  Writing critical assessments of published books, often
                  required in literature and social sciences courses.
                </p>
                <a href="/Academic_Services">Check Now</a>
              </div>
            </div>
          </div>
        </div>
        {/* card 09 */}
        <div className="col-lg-4 col-md-6 col-sm-12 text-start p-1" data-aos="flip-left">
          <div className="service-item service-dianuj">
            <div className="service-single">
              <div className="service-img">
                <img
                  src="/images/academic9.jpg"
                  alt="Service Frequency Calculator"
                  height="200px"
                  width="100%"
                />
              </div>
              <div className="service-content long-heading">
                <h3>
                  <a className="" href="/Academic_Services">
                    Lab Reports
                  </a>
                </h3>
                <p>
                  Documenting experiments and providing a comprehensive analysis
                  of results, commonly required in science courses.
                </p>
                <a href="/Academic_Services">Check Now</a>
              </div>
            </div>
          </div>
        </div>
        {/* card 10 */}
        <div className="col-lg-4 col-md-6 col-sm-12 text-start p-1" data-aos="flip-right">
          <div className="service-item service-dianuj">
            <div className="service-single">
              <div className="service-img">
                <img
                  src="/images/academic10.jpg"
                  alt="Service Frequency Calculator"
                  height="200px"
                  width="100%"
                />
              </div>
              <div className="service-content long-heading">
                <h3>
                  <a className="" href="/Academic_Services">
                    Article Critiques
                  </a>
                </h3>
                <p>
                  Critically evaluating journal articles and providing a
                  detailed assessment of the content, methodology, and
                  significance of the work.
                </p>
                <a href="/Academic_Services">Check Now</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AcademicWritingCards;
